import { render, staticRenderFns } from "./FooterComponent.vue?vue&type=template&id=0541f05c&"
import script from "./FooterComponent.vue?vue&type=script&lang=js&"
export * from "./FooterComponent.vue?vue&type=script&lang=js&"
import style0 from "./FooterComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports